'use client'
import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC, useCallback, useState } from 'react'

import Images from '@/components/EtsMap/Images'
import MapLegendBox from '@/components/EtsMap/MapLegendBox'
import MobileCarouselMap from '@/components/EtsMap/MobileCarouselMap'
import Select from '@/components/EtsMap/Select'

const InteractiveMap: FC = () => {
    const { smScreen } = useDevice()
    const [activeImageNumber, setActiveImageNumber] = useState<'1' | '2' | '3'>('1')
    const [activeSubImageNumber, setActiveSubImageNumber] = useState<'1' | '2' | '3'>('1')

    const change = useCallback((value: '1' | '2' | '3') => {
        setActiveImageNumber(value)
    }, [])

    const onSubSelectionChange = useCallback((subSelection: '1' | '2' | '3') => {
        setActiveSubImageNumber(subSelection)
    }, [])

    return (
        <>
            {smScreen ? (
                <MobileCarouselMap />
            ) : (
                <Box
                    sx={{
                        height: '680px',
                        width: '100%',
                        flex: '0 1 auto',
                        position: 'relative',
                        borderRadius: '24px',
                        overflow: 'hidden',
                    }}
                >
                    <Images activeImageNumber={`${activeImageNumber}${activeSubImageNumber}`} />
                    <Select onChange={change} />
                    <MapLegendBox
                        selection={activeImageNumber}
                        onSubSelectionChange={onSubSelectionChange}
                    />
                </Box>
            )}
        </>
    )
}

export default InteractiveMap
